<template>
  <el-dialog title= 实验室房间信息维护  :visible.sync="dialogFormVisible" :before-close="close" :close-on-click-modal = false>
    <el-form :model="form" :rules="rules" ref="ruleForm" label-width="100px">
      <el-form-item label="房间编号" :label-width="formLabelWidth" prop="LABROOM_NO">
        <el-input v-model="form.LABROOM_NO"></el-input>
      </el-form-item>
      <el-form-item label="房间名称" :label-width="formLabelWidth" prop="LABROOM_NAME">
        <el-input v-model="form.LABROOM_NAME"></el-input>
      </el-form-item>
      <el-form-item label="负责人" :label-width="formLabelWidth" prop="PERSON_NAME">
        <el-input v-model="form.PERSON_NAME"></el-input>
      </el-form-item>
      <el-form-item label="负责人电话" :label-width="formLabelWidth" prop="PERSON_PHONE">
        <el-input v-model="form.PERSON_PHONE"></el-input>
      </el-form-item>
      <el-form-item label="所属实验室" :label-width="formLabelWidth" prop="LAB_NO">
        <el-select v-model="form.LAB_NO" placeholder="请选择柜子类型">
          <el-option
                  v-for="(item, key) of labList"
                  :key="key"
                  :label="item.LAB_NAME"

                  :value="item.LAB_NO">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="makeSure('ruleForm')">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script type="text/ecmascript-6">
import laboratory from 'api/Management/laboratory.js'
const _laboratory = new laboratory()
const baseForm = {
    LABROOM_NO: '',
    LABROOM_NAME: '',
    PERSON_NAME: '',
    PERSON_PHONE: '',
    LAB_NO:'',
    LAB_NAME:'',
}
export default {
  props: {
    dialogFormVisible: Boolean,
      ruleForm: Object,
  },

  data() {
    return {
      labList:[],
      form: baseForm,
      formLabelWidth: '120px',
      formData:[],
      userList:[],
      rules: {

      },
      per_page: 5000,
      page: 1,
      list: 'all'
    }
  },
  mounted() {
    this.getlaboratory()
  },
  methods: {
      async submitForm() {
        this.labList.forEach(item =>{
          if (item.LAB_NO === this.form.LAB_NO) {
            this.form.LAB_NAME = item.LAB_NAME
          }
        })
          _laboratory.labRoomUpdate(this.form.LABROOM_NAME,this.form.LABROOM_NO,this.form.LAB_NAME,this.form.LAB_NO,this.form.PERSON_NAME,this.form.PERSON_PHONE)
              .then(res => {
                  this.$message({
                      message: '编辑成功！',
                      type: 'success'
                  })
              }).catch((err)=>{
            this.$message.error('编辑失败')
          })

      this.close()
    },
    makeSure(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitForm()
          this.$emit('getLaboratoryList')
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    close() {
      this.$emit('controlFormWindow', false)
    },
    //   获取柜子类型
    getlaboratory(){
      _laboratory.getLaboratoryType(this.per_page,this.page,this.list).then(res => {
        this.labList = res.items

      })
    },

  },
  components: {

  },
    watch: {
        ruleForm(newVal) {
            if (Object.keys(newVal).length > 0) {
                this.form = newVal
            }
        }
    }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">

</style>
